import axios from 'axios';
import { ApiResponseType } from '../../types/types';
import {
  AddPackageForUserResponse,
  GetMyPackageInfoResponse,
  GetPackagesResponse
} from './Maeketplace.types';
import { DASHBOARD, FLIPME_CARDS, TRADING } from '../../routes/routes';

export const getPackageAsync = async (): Promise<
  ApiResponseType<GetMyPackageInfoResponse>
> => {
  const { data } = await axios.get<ApiResponseType<GetMyPackageInfoResponse>>(
    `/package/my-package`
  );
  return data;
};

export const getPackagesAsync = async (): Promise<
  ApiResponseType<GetPackagesResponse>
> => {
  const { data } = await axios.get<ApiResponseType<GetPackagesResponse>>(
    `/package`
  );

  return data;
};

export const getPackagesTradingAsync = async (): Promise<
  ApiResponseType<GetPackagesResponse>
> => {
  const { data } = await axios.get<ApiResponseType<GetPackagesResponse>>(
    `/package/trading`
  );

  return data;
};

export const getPackagesBigWhaleAsync = async (): Promise<
  ApiResponseType<GetPackagesResponse>
> => {
  const { data } = await axios.get<ApiResponseType<GetPackagesResponse>>(
    `/package/big-whale`
  );

  return data;
};

export const getTravelPackagesAsync = async (): Promise<
  ApiResponseType<GetPackagesResponse>
> => {
  const { data } = await axios.get<ApiResponseType<GetPackagesResponse>>(
    `/products/travelution-memberships`
  );

  return data;
};

export const getTravelutionSubscriptionsAsync = async () => {
  const { data } = await axios.get(`/products/travelution-subscriptions`);

  return data;
};

export const getGoldenCardAsync = async () => {
  const { data } = await axios.get(`/products/travelution-golden-cards`);

  return data;
};

export const getTravelutionSubscriptionBundleAsync = async () => {
  const { data } = await axios.get(
    `/products/travelution-subscription-bundles`
  );

  return data;
};

export const getSuperSalesLicencesAsync = async () => {
  const { data } = await axios.get(`/products/travelution-super-sales`);

  return data;
};

export const addHubAsync = async ({
  packageId,
  currencyType,
  networkType,
  licenceId,
  userDiscountCodeId
}: {
  packageId: number;
  currencyType: number;
  networkType: number | null;
  licenceId: number | null;
  userDiscountCodeId: number | null;
}): Promise<ApiResponseType<AddPackageForUserResponse>> => {
  const isTradingHubs =
    window.location.pathname === TRADING ||
    window.location.pathname === DASHBOARD;

  if (isTradingHubs) {
    const { data } = await axios.post<
      ApiResponseType<AddPackageForUserResponse>
    >(
      '/package/trading',
      currencyType === 1
        ? {
            packageId,
            currencyType,
            networkType,
            licenceId,
            userDiscountCodeId
          }
        : { packageId, currencyType, licenceId, userDiscountCodeId }
    );

    return data;
  } else {
    const { data } = await axios.post<
      ApiResponseType<AddPackageForUserResponse>
    >(
      `/package/user`,
      currencyType === 1
        ? {
            packageId,
            currencyType,
            networkType,
            licenceId
          }
        : { packageId, currencyType, licenceId }
    );

    return data;
  }
};

export const purchaseNFTPackageAsync = async ({
  packageId,
  licenceId,
  lp,
  club,
  cash,
  usdt,
  usdc,
  networkType
}: {
  packageId: number;
  networkType: number | null;
  licenceId: number | null;
  lp: number;
  club: number;
  cash: number;
  usdt: number;
  usdc: number;
}): Promise<ApiResponseType<AddPackageForUserResponse>> => {
  const isFlipme = window.location.pathname === FLIPME_CARDS;

  const { data } = await axios.post<ApiResponseType<AddPackageForUserResponse>>(
    isFlipme ? `/package/flip-me` : `/package/nft`,
    {
      packageId,
      networkType,
      licenceId,
      lp,
      club,
      cash,
      usdt,
      usdc
    }
  );

  return data;
};

export const purchaseTradingPackageAsync = async ({
  packageId,
  licenceId,
  lp,
  club,
  cash,
  usdt,
  usdc,
  networkType,
  userDiscountCodeId
}: {
  packageId: number;
  networkType: number | null;
  licenceId: number | null;
  userDiscountCodeId: number | null;
  lp: number;
  club: number;
  cash: number;
  usdt: number;
  usdc: number;
}): Promise<ApiResponseType<AddPackageForUserResponse>> => {
  const { data } = await axios.post<ApiResponseType<AddPackageForUserResponse>>(
    `/package/v2/trading`,
    {
      packageId,
      networkType,
      licenceId,
      lp,
      club,
      cash,
      usdt,
      usdc,
      userDiscountCodeId
    }
  );

  return data;
};

export const purchaseBigWhalePackageAsync = async ({
  packageId,
  licenceId,
  lp,
  club,
  cash,
  usdt,
  usdc,
  networkType
}: {
  packageId: number;
  networkType: number | null;
  licenceId: number | null;
  lp: number;
  club: number;
  cash: number;
  usdt: number;
  usdc: number;
}): Promise<ApiResponseType<AddPackageForUserResponse>> => {
  const { data } = await axios.post<ApiResponseType<AddPackageForUserResponse>>(
    `/package/big-whale`,
    {
      packageId,
      networkType,
      licenceId,
      lp,
      club,
      cash,
      usdt,
      usdc
    }
  );

  return data;
};

export const purchaseTravelPackageAsync = async ({
  productId,
  email
}: {
  productId: number;
  email: string;
}) => {
  const { data } = await axios.post(`/products/travelution-memberships`, {
    productId,
    email
  });

  return data;
};

export const purchaseSubscriptionAsync = async ({
  productId,
  email
}: {
  productId: number;
  email: string;
}) => {
  const { data } = await axios.post(`/products/travelution-subscriptions`, {
    productId,
    email
  });

  return data;
};

export const purchaseGoldenCardAsync = async ({
  productId,
  email
}: {
  productId: number;
  email: string;
}) => {
  const { data } = await axios.post(`/products/travelution-golden-cards`, {
    productId,
    email
  });

  return data;
};

export const getGoldenCardStatusAsync = async () => {
  const { data } = await axios.get(
    `/products/travelution-golden-cards/my-orders/status`
  );

  return data;
};

export const purchaseSubscriptionBundleAsync = async ({
  productId,
  email
}: {
  productId: number;
  email: string;
}) => {
  const { data } = await axios.post(
    `products/travelution-subscription-bundles`,
    {
      productId,
      email
    }
  );

  return data;
};

export const purchaseSuperSalesAsync = async ({
  productId,
  email
}: {
  productId: number;
  email: string;
}) => {
  const { data } = await axios.post(`products/travelution-super-sales`, {
    productId,
    email
  });

  return data;
};
